import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { rd } from '@passionware/monads';

import { createContactPin } from 'store/v1/contacts/contacts.actions.js';
import { useBrowsingWorkspaceRoutes } from 'v5/core/app-scope/useBrowsingWorkspaceRoutes';
import { myServices } from 'v5/services/services.connected.app';

import MediaFromProfilePins from './MediaFromProfilePins/MediaFromProfilePins';

import get from 'lodash/get';
import { isProfilePinInGallery } from './isProfilePinInGallery';

const MediaFromProfile = ({
  onSelect,
  onRemoveFromGallery,
  contact_id,
  gallery = []
}) => {
  const dispatch = useDispatch();
  const contacts = useSelector(state => state.contacts);
  const contact = rd.tryGet(myServices.resourceService.useItem(contact_id));
  const routes = useBrowsingWorkspaceRoutes(myServices);
  const galleryRef = useRef(gallery);
  galleryRef.current = gallery;

  const handleSelectFromProfile = pin => {
    if (isProfilePinInGallery(pin, galleryRef.current)) return;
    const canTrackSourceContactPin =
      pin?.id != null &&
      (typeof pin.id === 'number' ||
        (typeof pin.id === 'string' && !pin.id.startsWith('temp-')));
    onSelect(
      canTrackSourceContactPin ? { ...pin, _sourceContactPinId: pin.id } : pin
    );
  };

  return (
    <div className="flex h-full min-h-0 min-w-0 flex-1 flex-col">
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <MediaFromProfilePins
          contacts={contacts}
          contact={contact}
          pins={get(contacts, ['associations_data', contact_id, 'pins'])}
          gallery={gallery}
          onSelect={handleSelectFromProfile}
          onRemoveFromGallery={onRemoveFromGallery}
          profileHref={routes.contacts.detail(contact_id)}
          createContactPin={data =>
            dispatch(createContactPin(data, contact_id))
          }
        />
      </div>
    </div>
  );
};

MediaFromProfile.propTypes = {
  onSelect: PropTypes.func.isRequired,
  onRemoveFromGallery: PropTypes.func.isRequired,
  contact_id: PropTypes.number.isRequired,
  gallery: PropTypes.array
};

export default MediaFromProfile;
